export enum DateTimeFormat {
  DATE_TIME = 'DD/MM/YYYY HH:mm (z) zzz',
  DATE = 'DD/MM/YYYY',
  TIME = 'HH:mm',
}
